(function () {
"use strict";
angular.module('app.modals.info', [])

    .controller('infoModalCtrl', ['$scope', 'close','infoObject',
        function ($scope, close,infoObject) {

            function closeTimeoutModalAutomatically() {
                $scope.timeoutActivated = true;
                setTimeout(() => {
                    if ($scope.timeoutActivated === true) {
                        $scope.close();
                    }
                }, 20 * 1000);
            }

            $scope.init = function(){
                $scope.infoObject = infoObject;
                if ($scope.infoObject.TitleTranslated) {
                    $scope.infoObject.Title = $scope.infoObject.TitleTranslated;
                }
                if ($scope.infoObject.DisplayTextTranslated) {
                    $scope.infoObject.DisplayText = $scope.infoObject.DisplayTextTranslated;
                }

                if (($scope.infoObject.Response
                     && $scope.infoObject.Response.data
                     && $scope.infoObject.Response.data.ExceptionData
                     && $scope.infoObject.Response.data.ExceptionData.ExeptionType === 9)
                   ) {
                    closeTimeoutModalAutomatically();
                }
            };
            $scope.dismissModal = function(){
                $scope.timeoutActivated = false;
                close();
            };
            $scope.close = function(){
                $scope.timeoutActivated = false;
                close();
            };
            $scope.init();

        }
    ])
    .factory('infoModal', ['ModalService', function (ModalService) {
        return function (infoObject) {
            return ModalService.showModal({
                controller: 'infoModalCtrl',
                templateUrl: "views/modals/info.html",
                inputs: {
                    infoObject:infoObject
                }
            });
        };
    }]);

})();
